import Immutable from 'immutable'

import { createService } from '../../../records'
import changePasswordReducer from './changePassword'

// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_SERVICES = 'inf/service/LOAD_SERVICES'
export const LOAD_SERVICES_CLIENT = 'inf/service/LOAD_SERVICES_CLIENT'
export const LOAD_SERVICES_IP = 'inf/service/LOAD_SERVICES_IP'
export const RECEIVE_SERVICES = 'inf/service/RECEIVE_SERVICES'

// ------------------------------------
// Actions
// ------------------------------------
export const loadService = serviceId => ({
  payload: { serviceIds: [serviceId] },
  type: LOAD_SERVICES,
})
export const loadServices = serviceIds => ({
  payload: { serviceIds },
  type: LOAD_SERVICES,
})
export const loadServicesByIps = ips => ({
  payload: { ips },
  type: LOAD_SERVICES_IP,
})
export const loadServicesForClient = clientId => ({
  payload: { clientId },
  type: LOAD_SERVICES_CLIENT,
})
export const receiveServices = services => ({
  payload: { services },
  type: RECEIVE_SERVICES,
})

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  changePassword: undefined,
  services: Immutable.Set(),
})

function replaceService(services, service) {
  return services
    .filter(c => c.id !== service.id)
    .add(service)
}

export default function reducer(state = initialState, action) {
  state = state.set('changePassword', changePasswordReducer(state.get('changePassword'), action))

  switch (action.type) {
    case RECEIVE_SERVICES:
      return state.set('services', action.payload.services.reduce(
        (services, rawService) => replaceService(services, createService(rawService)),
        state.get('services'),
      ))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/service/reducer.js